import React from 'react';
import { ShieldCheckIcon, DollarSignIcon, LockIcon, PackageIcon } from 'lucide-react';
interface TrustBadgeProps {
  icon: 'shield' | 'dollar' | 'lock' | 'package';
  text: string;
}
export function TrustBadge({
  icon,
  text
}: TrustBadgeProps) {
  const icons = {
    shield: ShieldCheckIcon,
    dollar: DollarSignIcon,
    lock: LockIcon,
    package: PackageIcon
  };
  const Icon = icons[icon];
  return <div className="flex flex-col items-center text-center gap-2" data-id="element-442">
      <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center" data-id="element-443">
        <Icon className="w-8 h-8 text-green-600" data-id="element-444" />
      </div>
      <p className="text-sm font-medium text-gray-700 max-w-[150px]" data-id="element-445">{text}</p>
    </div>;
}